
import { timeRangeOptions } from "@/utils/options";
import { FbaShipmentEnum } from "modules/common/logistics/enum";
import { statusOption } from './deliveryEnum'

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '状态',
    prop: 'statuses',
    components: [{
        name: 'gj-select',
        prop: 'statuses',
        propsData: {
            placeholder: '全部状态',
            options: statusOption.open,
            type:'multi-check',
        },
        style: {
            width: '300px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ['processing'],
    validator: [
        {required: true, message: '请选择默认状态', trigger: 'change'}
    ],
},{
    label: '发货仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            placeholder: '发货仓库',
            multiple: true,
            fba:false,
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: [
                {id: 'created', text: '统计时间'},
                {id: 'deliver', text: '发货时间'},
            ]
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }]

}, {
    label: '包装类型',
    prop: 'areCasesRequired',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'areCasesRequired',
        propsData: {
            placeholder: '包装类型',
            options:[{id: true, text: '原厂包装'}, {id: false, text: '混装'}]
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '关联调拨单',
    prop: 'relationTransfer',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'relationTransfer',
        propsData: {
            placeholder: '关联调拨单',
            options:[{id: true, text: '是'}, {id: false, text: '否'}]
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '关联货件',
    prop: 'relationShipment',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'relationShipment',
        propsData: {
            placeholder: '关联货件',
            options:[{id: true, text: '是'}, {id: false, text: '否'}]
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}]
